<template>
    <div class="select is-primary is-small">
        <select v-model="newBid.status" v-on:change="bidResult()">
            <option :value="this.$bidStatusCancel">Canceled</option>
            <option :value="this.$bidStatusActive">Active</option>
            <option :value="this.$bidStatusWin">Win</option>
            <option :value="this.$bidStatusLose">Lose</option>
            <option :value="this.$bidStatusLoseToOtherUser">Lose to other</option>
            <option :value="this.$bidStatusUnsold">Unsold</option>
            <option :value="this.$bidStatusUnderNegotiations">Negotiations</option>
        </select>
    </div>
</template>

<script>
    import apiBids from '../../api/apiBids'
    export default {
        props:['bid'],
        data() {
            return {
                newBid:{
                    id: this.bid.id,
                    status: this.bid.status,
                    group_name: this.bid.group.name,
                    group_id: this.bid.group.id
                }
            }
        },
        methods: {
            bidResult() {
                if(this.newBid.status === this.$bidStatusWin){
                    this.$store.dispatch('changeResultModalStatus', { status: true, bidId: this.newBid.id })

                }else {
                    apiBids
                        .updateBidRequest(this.newBid)
                        .then((response) => {
                            if(this.newBid.status == this.$bidStatusCancel){
                                this.$emit('classChanged', 'is-cancel')
                            }else{
                                this.$emit('classChanged', 'is-not-canceled')
                            }

                            if(this.newBid.status == this.$bidStatusUnsold){
                                this.$emit('statusChanged', this.$bidStatusUnsold)
                            }else{
                                this.$emit('statusChanged', 0)
                            }
                            this.$store.dispatch('toggleNegoStartPrice', {status: response.data.status, bidId: this.newBid.id});
                            console.log(response.data.original)
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                }
            }
        }
    }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Bids/BidStatus.vue